export const VERSION = {
    version: 'v1.0.56'
};
